import Button from '../Button';
import styles from './MiddleSchoolBackButton.module.scss';
import { Icon } from '@iconify/react';
import arrowIosBackOutline from '@iconify/icons-eva/arrow-ios-back-outline';

interface Props {
  handleClick: () => void;
}

const MiddleSchoolBackCustomClick = ({ handleClick }: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <Button onClick={handleClick}>
        <Icon icon={arrowIosBackOutline} width={30} />
      </Button>
    </div>
  );
};

export default MiddleSchoolBackCustomClick;
